module.exports = __webpack_public_path__ + "static/img/t50.0aa802dc.png";